import React from 'react';
import { Skeleton } from '@goodhuman-me/components';

const TableSkeleton = (): JSX.Element => (
  <div className="m-large" data-testid="loading-skeleton">
    <Skeleton.Root height={400}>
      <Skeleton.Heading size="xlarge" />
      {Array.from({ length: 8 }).map((_, index) => (
        <Skeleton.Heading key={index} y={60 + index * 40} />
      ))}
    </Skeleton.Root>
  </div>
);

export default TableSkeleton;
